import axios from "./axios";

export async function fetchShippingTypes() {
  return axios({
    method: "get",
    url: "/shipping_types/",
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response.data;
      }
      throw error;
    });
}
